// ╔═══════════════════════════════════════════════════════════════╗
// ║  FIREBASE CONFIGURATION                                      ║
// ║  Replace the values below with YOUR Firebase project config   ║
// ║  (See deployment guide for step-by-step instructions)         ║
// ╚═══════════════════════════════════════════════════════════════╝

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB5ESdQweaKqrw99tfQeLrExUQjZb0fPpM",
  authDomain: "novacert-ind.firebaseapp.com",
  projectId: "novacert-ind",
  storageBucket: "novacert-ind.firebasestorage.app",
  messagingSenderId: "448187001614",
  appId: "1:448187001614:web:22c7ad8fd75cc9a3bc455f",
  measurementId: "G-1HDSQJZSGR"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
